export default __webpack_public_path__ + "static/media/Slots_Arrow_Left.8f6a02eb.png";